export default "__VITE_PUBLIC_ASSET__f9f73ce0__"